import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import { Container, Row } from "react-bootstrap";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/no-autorizada",
    label: "No autorizada",
    isActive: true,
  },
];

function NoAutorizada() {
  return (
    <Page
      title="Página no autorizada"
      description="No tienes permiso para acceder a esta página."
      breadCrumbs={breadCrumbs}
    >
      <Container>
        <Row className="justify-content-center text-center mt-5">
          <h2>Página no autorizada</h2>
          <p className="text-muted">
            No tienes los permisos necesarios para acceder a esta página.
          </p>
        </Row>
      </Container>
    </Page>
  );
}

export default NoAutorizada;
